import React from 'react';
import Page from '@glowforge/gf-styled/src/components/contentful-views/page';
import ContentPageStyled from '@glowforge/gf-styled/src/components/content-page.styled';
import { pagePropType } from '../../prop-types/contentful';
import CustomPageMetadata from '../../components/custom-page-metadata';
import { getPage } from '../../api/contentful';
import Canonical from '../../util/canonical';

// TODO: Replace with dynamic importer
import '@glowforge/gf-styled/src/initializers/contentful-page';

const MaterialsPage = ({ page }) => (
    <>
      <Canonical path='materials'/>
      <CustomPageMetadata page={page} />
      <ContentPageStyled>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <Page className='MaterialsPage contentPage' {...page.fields}/>
      </ContentPageStyled>
    </>
  );

export const getServerSideProps = async () => {
  const page = await getPage('materials-page');
  return {
    props: { page }
  };
};

MaterialsPage.propTypes = {
  page: pagePropType.isRequired,
};

export default MaterialsPage;